/**
 * UUID v4 generator с fallback для non-secure contexts.
 *
 * Bug G (2026-05-19): `crypto.randomUUID()` требует secure context
 * (HTTPS / localhost / 127.0.0.1 / file://). На HTTP LAN IP (`192.168.x.x`)
 * на mobile Chrome/Safari API не defined → `TypeError: crypto.randomUUID is
 * not a function` → app crash. Этот polyfill использует native
 * `crypto.randomUUID()` когда доступен, иначе `Math.random()`-based
 * fallback (RFC 4122 v4 compliant format).
 *
 * **Не криптографически secure** fallback (Math.random — PRNG). Используется
 * только для внутренних IDs (draftId, custom row IDs, mock keys) — НЕ для
 * security tokens / session IDs / etc.
 *
 * @see https://developer.mozilla.org/docs/Web/API/Crypto/randomUUID
 */
export function genUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
